<form [formGroup]="approveForm()">
  <div class="flex flex-col gap-lg">
    <div class="gap-lg w-full">
      <div>
        <lib-rich-editor-dual-lang-text-area
          [inputFormControlName]="'comment'"
          [id]="'comment'"
          [name]="'comment'"
          [label]="'request_screen_send_forward_comment_label' | transloco"
          [placeholderEn]="
            'request_screen_send_forward_comment_placeholder' | transloco
          "
          [placeholderAr]="
            'request_screen_send_forward_comment_placeholder' | transloco
          "
          [width]="'100%'"
          [requiredEn]="false"
          [requiredAr]="false"
          [disabled]="false"
          [canResize]="false"
          [isSingleInput]="true" />
      </div>
    </div>

    <div class="flex justify-end gap-md mt-lg">
      <button
        type="button"
        (click)="onClose()"
        class="px-lg py-sm rounded-md text-neutral-600 bg-white border border-neutral-300 text-sm font-medium cursor-pointer">
        {{ 'request_screen_cancel_button' | transloco }}
      </button>
      <button
        type="button"
        (click)="onSubmit()"
        [class.opacity-30]="approveForm().invalid"
        [disabled]="approveForm().invalid"
        class="px-lg py-sm rounded-md text-white bg-primary-500 text-sm font-medium border-none cursor-pointer">
        {{ 'request_screen_submit_button' | transloco }}
      </button>
    </div>
  </div>
</form>
